import { atom } from 'jotai';

export type AuthAtomData =
  | { state: 'signIn' }
  | {
      state: 'afterSignUpSendEmail';
      email: string;
    }
  | {
      state: 'afterSignInSendEmail';
      email: string;
    }
  | {
      state: 'signInWithPassword';
      email: string;
    }
  | {
      state: 'sendEmail';
      email: string;
      emailType:
        | 'setPassword'
        | 'changePassword'
        | 'changeEmail'
        | 'verifyEmail';
    };

export const authAtom = atom<
  AuthAtomData & {
    openModal: boolean;
  }
>({
  openModal: false,
  state: 'signIn',
});
